import { Component, OnInit, Input } from '@angular/core';
import { DatastoreService } from '../../services';
import { CommonFunctionsService } from '../../services';

@Component({
  selector: 'app-custom-object-banner',
  templateUrl: './custom-object-banner.component.html',
  styleUrls: ['./custom-object-banner.component.scss']
})
export class CustomObjectBannerComponent {

  @Input() page:string;

  readonly pageChanged$;
  readonly currentPage;

  customObjects: any[];

  constructor(private readonly dataStore: DatastoreService, private commonFunctionsService: CommonFunctionsService) {
    this.pageChanged$ = this.dataStore.pageChanged;
    this.currentPage = this.dataStore.currentPage;
  }

  ngOnInit(): void {
    this.setup();
  }

  async setup() {
    try {
      const ceremony = this.dataStore.booking;
      await this.commonFunctionsService.setupCustomObjects(ceremony);              
    }
    catch (err) {
      console.error(err);
    }
    if (this.dataStore.customObjects) {
      if (this.dataStore.customObjects[this.page]) {
        this.customObjects = this.dataStore.customObjects[this.page];
      }
    }
  }

}
